<template >
  <div class="sub-page">
    <van-nav-bar
        title="用户资料"
        left-text="返回"
        left-arrow
        @click-left="$router.back()"
        id="topbar"
    />

    <div class="sub-page__body">
      <div class="topDiv">
        <van-cell-group>
          <van-field name="avatar" label="头像" input-align="right">
            <template #input>
              <img v-if="userInfo.avatar" class="headImg" :src="apiUrl + 'download/' + userInfo.avatar" @click="showAvatar(userInfo.avatar)"/>
              <van-uploader v-else disabled/>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field label="姓名" readonly :value="userInfo.nname" input-align="right"/>
        </van-cell-group>
        <van-cell-group>
          <van-field label="性别" readonly :value="userInfo.ssexName" input-align="right"/>
        </van-cell-group>
        <van-cell-group>
          <van-field label="邮箱" readonly :value="userInfo.email" input-align="right"/>
        </van-cell-group>
        <van-cell-group>
          <van-field readonly v-if="userInfo.groupName" label="组别" :value="userInfo.groupName" input-align="right"/>
          <van-field readonly v-else label="组别" value="无" input-align="right"/>
        </van-cell-group>
      </div>
    </div>

    <div class="sub-page__footer">
      <van-button block color="#1B75F6" native-type="button" @click="toModifyUser">修改</van-button>
    </div>
  </div>
</template>

<script>
    import $ from '@/fly'
    import { ImagePreview } from 'vant';
    import Setting from '@/setting';
    export default {
        name: 'common-userInfo',
        data () {
            return {
                userInfo: {},
                apiUrl: Setting.apiBaseURL
            }
        },

        methods: {
            showAvatar (id) {
                ImagePreview({
                    images: [
                        Setting.apiBaseURL + 'download/' + id
                    ],
                    closeable: true
                });
            },
            toModifyUser () {
                this.$router.push({ name: 'common-modifyUserInfo' });
            }
        },
        mounted () {
            $.get('user/' + this.$store.state.admin.user.info.username).then(res => {
                if (res.ssex === '0') {
                    res.ssexName = '男'
                } else if (res.ssex === '1') {
                    res.ssexName = '女'
                } else if (res.ssex === '2') {
                    res.ssexName = '保密'
                }
                this.userInfo = res;
            })
        }
    }
</script>

<style lang="less" scoped>
    /* 导航 + 内容 + 底部按钮三段式，替代「screen.height + position:fixed」 */
    .sub-page {
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        background-color: #F7F7F7;
    }

    .sub-page__body {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
    }

    .sub-page__footer {
        flex-shrink: 0;
        padding-bottom: env(safe-area-inset-bottom);
    }

    .topDiv {
        margin-top: 20px;
    }

    .headImg {
        width: 160px;
        height: 160px;
        border-radius: 15px;
    }
</style>
